import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Alert,
} from '@mui/material';

const ResolveDisputeDialog = ({ open, onClose, selectedItem, resolutionNotes, onResolutionNotesChange, onSubmit }) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle>Resolve Dispute</DialogTitle>
    <DialogContent>
      {selectedItem && (
        <>
          <Alert severity="info" sx={{ mt: 1, mb: 2 }}>
            Dispute Reason: {selectedItem.dispute_reason}
          </Alert>
          <TextField
            margin="dense"
            label="Resolution Notes"
            fullWidth
            multiline
            rows={4}
            variant="outlined"
            value={resolutionNotes}
            onChange={(e) => onResolutionNotesChange(e.target.value)}
          />
        </>
      )}
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button
        onClick={onSubmit}
        variant="contained"
        color="success"
        disabled={!resolutionNotes.trim()}
      >
        Resolve Dispute
      </Button>
    </DialogActions>
  </Dialog>
);

export default ResolveDisputeDialog;
